// campaigns/endpoints.js
import { factory } from "vivialconnect-js-core";

//NOTE: do not use spread syntax here.
//helper == {init, BASE_URL}
const helper = factory.initEndpoints();

export default {
  init: helper.init,
  campaignImport: () =>
    `${helper.BASE_URL}/admin/accounts/campaigns/import.json`,
};
